<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/rest-hours-management/rest-hour-settings"
          ></back-button>
          Add Rest Hour Setting
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Rest Hours Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`/rest-hours-management/rest-hour-settings`"
              >Rest Hour Settings</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label"
                    >Default 24-hour calculation</label
                  >
                  <div class="col-sm-10">
                    <my-select
                      style="margin: 9px !important"
                      disableFormControl="true"
                      :selection.sync="form.hour_calculation_id"
                      :suggestions="DefaultHourCalculations"
                      placeholder="Select Default 24-hour calculation"
                    ></my-select>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label">Compliance</label>
                  <div class="col-sm-10">
                    <my-select
                      style="margin: 9px !important"
                      disableFormControl="true"
                      :selection.sync="form.compliance_id"
                      :suggestions="compliances"
                      placeholder="Select Compliance"
                    ></my-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label"
                    >Copy working arrangement</label
                  >
                  <div class="col-sm-10">
                    <div class="form-check form-switch mb-2">
                      <input
                        type="checkbox"
                        v-model="form.is_copy_working"
                        class="form-check-input"
                        id="formSwitch1"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label">Copy from</label>
                  <div class="col-sm-10">
                    <my-select
                      style="margin: 9px !important"
                      disableFormControl="true"
                      :selection.sync="form.copy_from"
                      :suggestions="CopyFroms"
                      placeholder="Select Copy from"
                    ></my-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label"
                    >Save non conformity working arrangement</label
                  >
                  <div class="col-sm-10">
                    <div class="form-check form-switch mb-2">
                      <input
                        type="checkbox"
                        v-model="form.is_non_conformity"
                        class="form-check-input"
                        id="formSwitch1"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label"
                    >Hours in Any 7 days columns</label
                  >
                  <div class="col-sm-10">
                    <div class="form-check form-switch mb-2">
                      <input
                        type="checkbox"
                        v-model="form.is_hour_in_any_7day"
                        class="form-check-input"
                        id="formSwitch1"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label"
                    >Confirmation on save non conformity</label
                  >
                  <div class="col-sm-10">
                    <div class="form-check form-switch mb-2">
                      <input
                        type="checkbox"
                        v-model="form.is_confirmation_save_non_conformity"
                        class="form-check-input"
                        id="formSwitch1"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label"
                    >NC time based on</label
                  >
                  <div class="col-sm-10">
                    <my-select
                      style="margin: 9px !important"
                      disableFormControl="true"
                      :selection.sync="form.nc_time_based_on"
                      :suggestions="NCTimeBaseds"
                      placeholder="Select NC time based on"
                    ></my-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label">NC marking</label>
                  <div class="col-sm-10">
                    <my-select
                      style="margin: 9px !important"
                      disableFormControl="true"
                      :selection.sync="form.nc_marking"
                      :suggestions="NCTimeBaseds"
                      placeholder="Select NC marking"
                    ></my-select>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row mb-3">
                  <label class="col-sm-8 col-form-label"
                    >Maximum Rest hour breaks validation in a day (No more than
                    2 breaks)</label
                  >
                  <div class="col-sm-4">
                    <div class="form-check form-switch mb-2">
                      <input
                        type="checkbox"
                        v-model="form.is_max_rest_hr_break_validation"
                        class="form-check-input"
                        id="formSwitch1"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label"
                    >Rest hours NC alert days duration</label
                  >
                  <div class="col-sm-10">
                    <input
                      type="text"
                      v-model="form.rest_hour_nc_alert_day_duration"
                      class="form-control"
                      placeholder="Rest hours NC alert days duration"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="row mb-3">
                  <label class="col-sm-6 col-form-label"
                    >Include Foot notes in Reports</label
                  >
                  <div class="col-sm-6">
                    <div class="form-check form-switch mb-2">
                      <input
                        type="checkbox"
                        v-model="form.is_foot_note"
                        class="form-check-input"
                        id="formSwitch1"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3" v-if="form.is_foot_note">
                  <label class="col-sm-2 col-form-label">Foot Reports</label>
                  <div class="col-sm-10">
                    <input
                      type="text"
                      v-model="form.foot_note"
                      class="form-control"
                      placeholder="Rest hours NC alert days duration"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label"
                >Editable Crew general data in Vessel</label
              >
              <div class="col-sm-10">
                <div class="form-check form-switch mb-2">
                  <input
                    type="checkbox"
                    v-model="form.is_editable_crew_general_data_vessel"
                    class="form-check-input"
                    id="formSwitch1"
                  />
                </div>
              </div>
            </div>

            <h4>Vessel Exceptions</h4>
            <hr />
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Vessel</th>
                    <th>24-hour calculation</th>
                    <th>Copy from</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <loading-table
                    :isLoading="isLoading"
                    cols="11"
                  ></loading-table>
                  <tr v-if="form.rest_hour_setting_details.length == 0">
                    <td colspan="11" class="text-center">No data Found</td>
                  </tr>
                  <tr
                    v-for="(
                      rest_hour_setting_detail, ar
                    ) in form.rest_hour_setting_details"
                    :key="`rest_hour_setting_detail${ar}`"
                  >
                    <td>{{ ar + 1 }}.</td>
                    <td>
                      <my-select
                        disableFormControl="true"
                        :selection.sync="rest_hour_setting_detail.vessel_id"
                        :suggestions="vessels"
                        placeholder="Select Vessel"
                      ></my-select>
                    </td>
                    <td>
                      <my-select
                        disableFormControl="true"
                        :selection.sync="
                          rest_hour_setting_detail.hour_calculation_id
                        "
                        :suggestions="DefaultHourCalculations"
                        placeholder="Select Compliance"
                      ></my-select>
                    </td>
                    <td>
                      <my-select
                        disableFormControl="true"
                        :selection.sync="rest_hour_setting_detail.copy_from"
                        :suggestions="CopyFroms"
                        placeholder="Select Copy from"
                      ></my-select>
                    </td>

                    <td>
                      <div class="text-center">
                        <button
                          class="btn btn-danger btn-sm"
                          @click="deletePartNumber(rest_hour_setting_detail)"
                          v-if="!rest_hour_setting_detail.id"
                        >
                          Delete
                        </button>
                        <button
                          class="btn btn-danger btn-sm"
                          @click="
                            delete_part_number_data(rest_hour_setting_detail.id)
                          "
                          v-else
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="form.rest_hour_setting_details">
                    <td
                      colspan="11"
                      align="center"
                      @click="addEmptyPartNumber()"
                      style="
                        background-color: #6571ff;
                        color: white;
                        border-radius: 10px;
                        box-shadow: none;
                      "
                    >
                      Add New Row
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";

export default {
  name: "Rest Hour SettingCreate",
  data() {
    return {
      form: {
        vessel_id: "",
        copy_from: "",
        nc_time_based_on: "",
        rest_hour_setting_details: [
          {
            vessel_id: "",
            copy_from: "",
            nc_time_based_on: "",
          },
        ],
      },
      DefaultHourCalculations: [],
      vessels: [],
      compliances: [],
      CopyFroms: [
        { id: "Sea", name: "Sea" },
        { id: "Port", name: "Port" },
      ],
      NCTimeBaseds: [
        { id: "Rest Hour", name: "Rest Hour" },
        {
          id: "Mixed (rest and working hours)",
          name: "Mixed (rest and working hours)",
        },
        { id: "Working hour", name: "Working hour" },
      ],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("rest_hour_settings/masters");
      masters = masters.data;
      masters.vessels.forEach((vessel) => {
        this.vessels.push({
          id: vessel.id,
          name: vessel.name,
        });
      });
      masters.compliances.forEach((compliance) => {
        this.compliances.push({
          id: compliance.id,
          name: compliance.name,
        });
      });
      masters.hour_calculations.forEach((hour_calculation) => {
        this.DefaultHourCalculations.push({
          id: hour_calculation.id,
          name: hour_calculation.name,
        });
      });
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/rest_hour_settings", this.form);
        this.isLoading = false;
        this.$router.push("/rest-hours-management/rest-hour-settings");
      } catch (e) {
        this.isLoading = false;
      }
    },
    deletePartNumber(bankDetail) {
      this.form.rest_hour_setting_details =
        this.form.rest_hour_setting_details.filter((ar) => ar != bankDetail);
    },
    addEmptyPartNumber() {
      this.form.rest_hour_setting_details.push({
        // supplier_detail_id: this.form.id,
        company_id: this.company.id,
        part_number: "",
      });
    },
    async delete_part_number_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(
            `delete?id=${id}&table_name=rest_hour_setting_details`
          );
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
